// extracted by mini-css-extract-plugin
export default {"main":"main__GS3ffhv6","tableWrapper":"table-wrapper__HMiRBd6e"};